import { Card, Icon, styled, Typography } from '@mui/material';

interface InfoCardProps {
  icon?: React.ReactNode;
  headline: string;
  body: string;
}

export const InfoCard: React.FC<InfoCardProps> = ({ icon = 'sms_outlined', headline, body }) => {
  return (
    <StyledCard>
      <StyledIcon className='material-icons-outlined'>{icon}</StyledIcon>
      <TextContainer className='text-container'>
        <Typography
          variant='body2'
          color='primary'
          textTransform={'uppercase'}
        >
          {headline}
        </Typography>
        <Typography variant='body2'>{body}</Typography>
      </TextContainer>
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--mui-palette-border-secondary);
  box-shadow: var(--shadow-large);
`;

const StyledIcon = styled(Icon)`
  flex-shrink: 0;
  color: var(--mui-palette-primary-main);
  font-size: 40px;
`;

const TextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
